import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    emailSchedulerList: [],
     emailSchedulerRecord: [],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false, 
}

const EmailSchedulerReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.EMAIL_SCHEDULER_REQUEST:
            return {
                ...state,
                Loading: true,
                validation_error: "",
                redirect_to_list: false,
            }
        case actionTypes.EMAIL_SCHEDULER_SERVER_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                showUpdateForm: false,
                showViewPage: false,
                emailSchedulerRecord: [],
            }    
        case actionTypes. EMAIL_SCHEDULER_SUCCES:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
               emailSchedulerList: action.emailSchedulerList,
                showUpdateForm: false,
                showViewPage: false,
                emailSchedulerRecord: [],
            }
        case actionTypes. EMAIL_SCHEDULER_GET_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                emailSchedulerRecord: action.record,
                showUpdateForm: (action.actionType === 'update') ? true : false,
                showViewPage: (action.actionType === 'view') ? true : false
            }
        case actionTypes. EMAIL_SCHEDULER_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,
            }
        case actionTypes.HIDE_EMAIL_REPORT_SETUP_FEILD_VALIDATION_ERROR:
            if (state.validation_error && state.validation_error[action.feild_key])
                delete state.validation_error[action.feild_key]
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,

            }
        case actionTypes. REDIRECT_TO_EMAIL_SCHEDULER_LIST:
            return {
                ...state,
                redirect_to_list: true,
                showUpdateForm: false,
                showViewPage: false,
                validation_error: "",
                emailSchedulerRecord: [],
            }
        default:
            return state;
    }
}

export default EmailSchedulerReducer;